package meineglasfaser.frontend.www.pages.portal

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.api.OrderWithEntries
import meineglasfaser.api.ShopPriceGroup
import meineglasfaser.api.formatted
import meineglasfaser.api.routes.CustomerPortalRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.PriceGroupView
import meineglasfaser.frontend.common.components.widgets.UBLPostalAddressView
import meineglasfaser.frontend.common.components.widgets.rememberQuery
import meineglasfaser.frontend.common.withAuth
import meineglasfaser.frontend.www.components.LocalCustomerState
import meineglasfaser.frontend.www.pages.explore.PriceView
import org.jetbrains.compose.web.dom.Article
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.Small
import org.jetbrains.compose.web.dom.Text

@Page
@Layout(".components.layouts.PortalLayout")
@Composable
fun OrdersPage() {
    val accountInfo = LocalCustomerState.current.accountInfoOrNull() ?: return

    val orders = rememberQuery<List<OrderWithEntries>>(emptyList()) {
        BackendApi.get(CustomerPortalRoutes.ListOrders()) {
            withAuth()
        }
    }

    Div({ classes("row-fluid") }) {
        Div({ classes("col-12") }) {
            if (orders.isEmpty()) {
                Article {
                    Text("Sie haben noch keine Bestellungen aufgegeben.")
                    Br()
                    Anchor("/") {
                        Text("Zum Shop")
                    }
                }
            } else {
                orders.forEach { orderWithEntries ->
                    OrderWithEntryCard(orderWithEntries)
                }
            }
        }
    }
}

@Composable
private fun OrderWithEntryCard(orderWithEntries: OrderWithEntries) {
    val (order, entries) = orderWithEntries
    val accountInfo = LocalCustomerState.current.accountInfoOrNull()

    val taxedEntryPrices = entries.map { entry ->
        ShopPriceGroup(
            monthly = entry.product.monthlyPrice.withTax(entry.product.monthlyTaxCategory),
            yearly = entry.product.yearlyPrice.withTax(entry.product.yearlyTaxCategory),
            once = entry.product.oncePrice.withTax(entry.product.onceTaxCategory),
        ) * entry.quantity
    }
    val total = taxedEntryPrices.fold(ShopPriceGroup.ZERO_EUR) { acc, price -> acc + price }

    Article {
        Header {
            Text("Bestellung ${order.nid}")
            Small {
                Text(" am ")
                Text(order.createdAt.formatted())
            }
        }
        B { Text("Lieferadresse") }
        Br()
        UBLPostalAddressView(order.deliveryAddress, vertical = true, showCountry = true)
        Div({ classes("row-fluid") }) {
            Div({ classes("col-12") }) {
            }
            entries.forEachIndexed { idx, entry ->
                val taxedPrice = taxedEntryPrices[idx]
                Div({ classes("col-6") }) {
                    Text("${entry.quantity}× ${entry.product.title}")
                }
                Div({ classes("col-6") }) {
                    PriceGroupView(taxedPrice, includesTax = true)
                }
            }
            Div({ classes("col-6") }) {
                Text("Gesamtsumme:")
            }
            Div({ classes("col-6") }) {
                PriceGroupView(total, includesTax = true)
            }
        }
    }
}
